import { render } from "./MaterialSelection.vue?vue&type=template&id=1f14da05"
import script from "./MaterialSelection.vue?vue&type=script&lang=js"
export * from "./MaterialSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__